import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import PatientLoader from "../../../../common/PatientLoader";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import { pinnedContentLabelsColors } from "../../../../../constants/constants";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PinnedBarChart = ({
  title,
  patientPinnedContent,
  pinnedContentLoading,
}) => {
  const [formattedData, setFormattedData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [labels, setLabels] = useState([]);
  const nameLookup = {
    Article: "Articles",
    Videos: "Videos",
    ViewMedica: "Videos",
    TikToks: "Tik Toks",
    Audio: "Audio",
  };
  useEffect(() => {
    if (
      !pinnedContentLoading &&
      patientPinnedContent 
      &&
      patientPinnedContent?.length > 0
    ) 
    {
      const colorIndex = Object.values(pinnedContentLabelsColors).slice(0, 4);
      //New Code
      const contentData = {
        Videos: 0,
        Audio: 0,
        Article: 0,
      };
      patientPinnedContent.forEach((item) => {
        if (item?.type in nameLookup) {
          contentData[item?.type] = contentData[item?.type] + 1;
        }
      });

      const tempData = {};
      patientPinnedContent.forEach((item) => {
        if (item?.type in tempData) {
          tempData[nameLookup[item?.type]] += 1;
        } else {
          tempData[nameLookup[item?.type]] = 1;
        }
      });

      const tempLabels = Object.keys(contentData);
      setLabels(tempLabels);
      const tempValues = Object.values(contentData);
      setFinalData(tempValues);
      const data = Object.entries(contentData).map((item, index) => {
        let prepareData = [];
        for (let i = 0; i <= tempLabels.length; i++) {
          if (i === index) {
            prepareData.push(item[1]);
          } else {
            prepareData.push(null);
          }
        }
        return {
          label: item[0],
          data: prepareData,
          borderColor: colorIndex[index],
          backgroundColor: colorIndex[index],
        };
      });
      setFormattedData(data);
    }
  }, [pinnedContentLoading, patientPinnedContent]);

  const data = {
    labels: labels,
    datasets: formattedData,
  };
  const options = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
        },
        ticks: {
          max: 100,
          min: 0,
          stepSize: 1 * formattedData.length,
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          useBorderRadius: true,
          borderRadius: 100,
          pointStyle: "circle",
          family: "'DM Sans'",
        },
        position: "bottom",
        align: "start",
      },
      title: {
        display: true,
        fontSize: 40,
        family: "'DM Sans'",
        text: title,
        align: "start",
      },
    },
  };

  return (
    <CardLayout
      className="col-sm-12 col-md-6 col-lg-6 p-5"
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      {pinnedContentLoading ? (
        <PatientLoader />
      ) : (
        <div className="container-fluid">
          <Bar options={options} data={data} height={150} />
        </div>
      )}
    </CardLayout>
  );
};

export default PinnedBarChart;
